import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import {
  AnalyticsState,
  changeAnalyticsState,
  decodeAnalyticsState,
  encodeAnalyticsState,
} from "./analyticsState";

/**
 * The analytics page's state, read from the address, and a function that
 * changes it.
 *
 * Every change is a new entry of the browser's history, so the back button
 * steps through the states. The parameters the state does not own (the
 * detail overlay's) are kept.
 */
export function useAnalyticsState(): [
  AnalyticsState,
  (change: Partial<AnalyticsState>) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const state = useMemo(
    () => decodeAnalyticsState(searchParams),
    [searchParams],
  );

  const change = useCallback(
    (part: Partial<AnalyticsState>) => {
      setSearchParams((current) =>
        encodeAnalyticsState(
          changeAnalyticsState(decodeAnalyticsState(current), part),
          current,
        ),
      );
    },
    [setSearchParams],
  );

  return [state, change];
}
